import type { IsValidFileToUploadProps } from "./upload-file-validator.type";
import type { UploadRcFile } from "../upload-file.type";

import { getFileUploadType } from "../upload-file.helper";

export const isValidFileToUpload = ({
  file,
  authorizedFileTypes,
}: IsValidFileToUploadProps) => {
  const fileType = getFileUploadType(file);
  if (!fileType) return false;
  return authorizedFileTypes.includes(fileType);
};

export const isValidFileSize = (file: UploadRcFile, maxFileSize: number) => {
  return file.size / 1024 / 1024 < maxFileSize;
};
